import {Box} from '@mui/material';
import Lottie from 'lottie-react';

import ChangeTextWithColorAndImage from '@/app/shared-components/ColorAndImageText/ColorAndImageText';
import {CSpinner} from '@/constants/SpinnerConstants';

import {useViewModelProvider, ViewModelProvider} from './ViewModelContext';

import './styles';

const CreatingKidContent = () => {
  const {selectedTheme, loaderText} = useViewModelProvider();

  return (
    <Box className="creating-container">
      <Box className="loader-container">
        <Box
          className="logo"
          component="img"
          src="/assets/images/logo/modak-circle-logo.svg"
          alt="Modak Logo"
          sx={{
            width: '64px',
          }}
        />
        <Lottie
          animationData={CSpinner.ELLIPSE_PATH}
          loop
          autoplay
        />
        <Box
          className="logo"
          component="img"
          src={`/assets/images/cards/MoCardLoading-${selectedTheme}.webp`}
          alt="Modak Card"
          sx={{
            width: '75px',
          }}
        />
      </Box>
      {loaderText.map((loader, index) => (
        <ChangeTextWithColorAndImage
          key={loader.text + index}
          text={loader.text}
          textStyle={{
            color: !loader.completed ? '#191C1B' : '#646867',
            opacity: !loader.completed ? 1 : 0.2,
            fontFamily: 'Poppins',
            fontSize: 22,
            fontStyle: 'normal',
            fontWeight: 600,
            letterSpacing: -0.22,
            textAlign: 'center',
          }}
        />
      ))}
      <Box className="note-container">
        <p className="note">
          “Absolutely no issues one month in - helpful customer service. Trying
          to teach financial literacy to an almost 13 year old is challenging -
          Modak helps”
        </p>
        <Box
          className="logo"
          component="img"
          src="/assets/images/pages/stars.svg"
          alt="Modak Logo"
        />
        <Box>
          <label>Kerry K. • Aug 31</label>
        </Box>
      </Box>
    </Box>
  );
};

const CreatingKidPage = () => {
  return (
    <ViewModelProvider>
      <CreatingKidContent />
    </ViewModelProvider>
  );
};

export default CreatingKidPage;
